import React from "react";
import { HAMICON } from "../../../lib/constants";

export default function Hamicon() {
  return <i id={HAMICON} className="fa-solid fa-bars text-xl cursor-pointer" />;
}
